import React from 'react';

export default function LossPreventionIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_22278_123100)">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.73561 6.83231L5.57541 4.09303H11.9995V1.57852H18.6545V0.28125L23.7181 3.2048L19.4735 5.65575L20.2635 6.83231H13.2222L13.0261 4.87144H10.9733L10.7828 6.83231H3.73561ZM11.9995 22.426H5.35041V23.7179L0.28125 20.794L3.47034 18.9542V7.61667H10.7425V9.60614L11.3711 9.11025L11.9995 9.60614L12.6339 9.11025L13.2625 9.60614V7.61667H20.5231L20.5289 19.9115H11.9995V22.426ZM10.7425 19.1331H13.2625V17.5298L12.6339 18.0317L11.9995 17.5298L11.3711 18.0317L10.7425 17.5298V19.1331ZM10.3157 11.0538H13.6893C14.2083 11.0538 14.6352 11.4805 14.6352 11.9994C14.6352 12.5184 14.2083 12.9452 13.6893 12.9452H10.3157C9.79655 12.9452 9.36994 12.5184 9.36994 11.9994C9.36989 11.4805 9.79655 11.0538 10.3157 11.0538ZM12.7839 4.05267H19.4388V4.77919L22.1552 3.2048L19.4388 1.63603V2.36287H12.7839V4.05267ZM11.2211 21.6418V19.9521H4.56609V19.2253L1.84397 20.794L4.56609 22.3685V21.6418H11.2211Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_22278_123100">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}